import type { TOptions, i18n } from 'i18next';

import { useTranslation as useI18nextTranslation } from 'react-i18next';

import LocalizationJSON from './en_dev.json';

export const useTranslation = (): { i18n: i18n; t: TFunction } => {
  const { i18n, t } = useI18nextTranslation();
  return {
    i18n,
    t: (key: LocalizationKey, options?: TOptions) => t(key, options),
  };
};

export type LocalizationKey = keyof typeof LocalizationJSON;

export type TFunction = (key: LocalizationKey, options?: TOptions) => string;
